import React, { useEffect, useState } from "react";
import { Accordion, Icon, Header } from "semantic-ui-react";
import { awhvFAQ } from "../../../assets/generalAssets";

import "./style.css";

const FAQAccordion = () => {

    const [activeIndex, setActiveIndex] = useState(0);

    const handleClick = (e, titleProps) => {
        const { index } = titleProps;
        const newIndex = activeIndex === index ? -1 : index;
        setActiveIndex(newIndex);
    };

    return (
        <div id="awhv-faq-accordion-container">
            <Header as="h1" id="awhv-faq-accordion-header">Frequently Asked Questions</Header>
            <Accordion id="awhv-faq-accordion" fluid styled>
                {awhvFAQ.map((faq, index) => {
                    return (
                        <div key={index}>
                            <Accordion.Title
                                className="awhv-faq-accordion-title"
                                active={activeIndex === index + 1}
                                index={index + 1}
                                onClick={handleClick}
                            >
                                <Icon name="dropdown" />
                                {faq.question}
                            </Accordion.Title>
                            <Accordion.Content className="awhv-faq-accordion-content" active={activeIndex === index + 1}>
                                <p className="awhv-faq-accordion-text">{faq.answer}</p>
                            </Accordion.Content>
                        </div>
                    );
                })}
            </Accordion>
        </div>
    );
};

export default FAQAccordion;